import angular from 'angular';
import 'angular-sanitize';

const app = angular.module('Toke', ['ngSanitize']);

export default app;
